import * as React from "react";
const SvgAssistant = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.69275 13.6009V11.4475H5.84614",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.5042 6.97325C13.7327 8.1923 13.55 9.45272 12.9847 10.5567C12.4195 11.6607 11.5037 12.5458 10.3811 13.0731C9.25853 13.6005 7.99262 13.7402 6.78205 13.4703C5.57148 13.2005 4.48475 12.5364 3.69238 11.5822M2.49586 9.03112C2.26739 7.81206 2.4501 6.55165 3.01533 5.44765C3.58056 4.34365 4.49632 3.45855 5.61892 2.93123C6.74152 2.4039 8.00743 2.2642 9.218 2.53404C10.4286 2.80388 11.5153 3.468 12.3077 4.42218",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.3074 2.40381V4.5572H10.154M5.47382 8.29263C5.16905 8.23966 5.16905 7.80204 5.47382 7.74907C6.01327 7.65471 6.51248 7.40207 6.90798 7.02327C7.30348 6.64447 7.57741 6.15662 7.69493 5.62173L7.71317 5.53751C7.77916 5.23621 8.2081 5.23447 8.2767 5.5349L8.29927 5.63302C8.42056 6.16583 8.69673 6.65087 9.09303 7.02709C9.48934 7.40331 9.98807 7.6539 10.5265 7.74733C10.833 7.8003 10.833 8.24053 10.5265 8.29436C9.98818 8.38773 9.48953 8.6382 9.09324 9.01425C8.69694 9.39031 8.42071 9.87516 8.29927 10.4078L8.2767 10.5051C8.2081 10.8055 7.77916 10.8038 7.71317 10.5025L7.6958 10.4191C7.57816 9.88398 7.30397 9.39595 6.90814 9.01713C6.51231 8.6383 6.01272 8.3858 5.47295 8.29176L5.47382 8.29263Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgAssistant;
